<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="sm:px-6 px-4 py-3 text-sm text-gray-900 align-top w-64">
      <div class="aspect-ratio-4/3 rounded relative overflow-hidden">
        <img v-if="cover" :src="cover.url" class="absolute inset-0 w-full h-full object-cover" />
        <div
          v-else
          class="absolute inset-0 w-full h-full flex items-center justify-center bg-gray-100"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-10 h-10 text-gray-500"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
            />
          </svg>
        </div>
      </div>
    </td>
    <td class="sm:px-6 px-4 py-3 text-sm text-gray-900 align-top">
      <RouterLink
        :to="{ name: 'admin.products.memberships.membership', params: { productId: product.id } }"
      >
        {{ product.name }}
      </RouterLink>
    </td>
    <td class="w-0 align-top sm:px-6 px-4 py-3">
      <MoreAction :product="product" @deleted="$emit('deleted')" />
    </td>
  </tr>
</template>

<script>
import MoreAction from './MoreAction.vue';

export default {
  components: {
    MoreAction,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cover() {
      return this.product?.media?.[0] || null;
    },
  },
};
</script>
